import { render, staticRenderFns } from "./templateView.vue?vue&type=template&id=51e1896c&scoped=true&"
import script from "./templateView.vue?vue&type=script&lang=js&"
export * from "./templateView.vue?vue&type=script&lang=js&"
import style0 from "./templateView.vue?vue&type=style&index=0&id=51e1896c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e1896c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51e1896c')) {
      api.createRecord('51e1896c', component.options)
    } else {
      api.reload('51e1896c', component.options)
    }
    module.hot.accept("./templateView.vue?vue&type=template&id=51e1896c&scoped=true&", function () {
      api.rerender('51e1896c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/incomingInspectionMgr/nskTemplateMgr/components/templateView.vue"
export default component.exports